$(document).ready(function() {
  $('.slider-promotion').slick({
    infinite: false, 
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    prevArrow: '<button class="cstm_previ"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_419)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.3663 16.2417C10.132 16.0073 10.0004 15.6894 10.0004 15.3579C10.0004 15.0265 10.132 14.7086 10.3663 14.4742L17.4376 7.40291C17.5529 7.28352 17.6908 7.1883 17.8433 7.12278C17.9958 7.05727 18.1599 7.02279 18.3258 7.02135C18.4918 7.01991 18.6564 7.05153 18.81 7.11438C18.9637 7.17724 19.1032 7.27005 19.2206 7.38742C19.338 7.50478 19.4308 7.64435 19.4936 7.79797C19.5565 7.95159 19.5881 8.11619 19.5867 8.28216C19.5852 8.44814 19.5507 8.61216 19.4852 8.76467C19.4197 8.91717 19.3245 9.0551 19.2051 9.17041L13.0176 15.3579L19.2051 21.5454C19.4328 21.7812 19.5588 22.0969 19.5559 22.4247C19.5531 22.7524 19.4216 23.0659 19.1899 23.2977C18.9581 23.5294 18.6446 23.6609 18.3168 23.6638C17.9891 23.6666 17.6733 23.5406 17.4376 23.3129L10.3663 16.2417Z" fill="#535454"></path></g></g><defs><clipPath id="clip0_1_419"><rect width="30" height="30" fill="white" transform="translate(9.15527e-05 0.35791)"></rect></clipPath></defs></svg></button>',
    nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g clip-path="url(#clip0_443_7893)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.634 16.2584C19.8684 16.024 20 15.7062 20 15.3747C20 15.0432 19.8684 14.7254 19.634 14.4909L12.5628 7.4197C12.4475 7.30031 12.3095 7.20508 12.157 7.13957C12.0045 7.07406 11.8405 7.03958 11.6745 7.03813C11.5085 7.03669 11.3439 7.06832 11.1903 7.13117C11.0367 7.19402 10.8971 7.28684 10.7798 7.4042C10.6624 7.52157 10.5696 7.66113 10.5067 7.81475C10.4439 7.96837 10.4123 8.13297 10.4137 8.29895C10.4151 8.46492 10.4496 8.62895 10.5151 8.78145C10.5806 8.93396 10.6759 9.07189 10.7953 9.1872L16.9828 15.3747L10.7953 21.5622C10.5676 21.798 10.4416 22.1137 10.4444 22.4415C10.4473 22.7692 10.5787 23.0827 10.8105 23.3145C11.0423 23.5462 11.3558 23.6777 11.6835 23.6805C12.0113 23.6834 12.327 23.5574 12.5628 23.3297L19.634 16.2584Z" fill="#535454"/></g><defs><clipPath id="clip0_443_7893"><rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 30 0.375)"/></clipPath></defs></svg></button>',   
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 427,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  function updateArrowState() {
    var currentSlide = $('.slider-promotion').slick('slickCurrentSlide');
    var totalSlides = $('.slider-promotion .slick-slide').not('.slick-cloned').length;

    if (currentSlide === 0) {
      $('.cstm_previ').removeClass('active');
    } else {
      $('.cstm_previ').addClass('active');
    }
    if (currentSlide >= totalSlides - $('.slider-promotion').slick('slickGetOption', 'slidesToShow')) {
      $('.cstm_nexts').removeClass('active');
    } else {
      $('.cstm_nexts').addClass('active');
    }
  }
  updateArrowState();
  $('.slider-promotion').on('afterChange', function() {
    updateArrowState();
  });

  $(document).on('click', '.cstm_previ', function() {
    $('.slider-promotion').slick('slickPrev');
  });

  $(document).on('click', '.cstm_nexts', function() {
    $('.slider-promotion').slick('slickNext');
  });
});
 $('body').on('click','.cstm__read_more_filter',function(){
     $(this).hide();
     $(this).parents('ul').find('li').show();
   })

 
// promotion slider 

  $(document).ready(function() {
    $('.new_slider_left').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
      prevArrow: '<button class="cstm_previ"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.365983 10.1344C0.131644 9.90001 0 9.58213 0 9.25067C0 8.91922 0.131644 8.60133 0.365983 8.36692L7.43723 1.29567C7.55254 1.17629 7.69047 1.08106 7.84298 1.01555C7.99548 0.950035 8.15951 0.915552 8.32548 0.91411C8.49146 0.912667 8.65606 0.944295 8.80968 1.00715C8.9633 1.07 9.10286 1.16281 9.22023 1.28018C9.3376 1.39755 9.43041 1.53711 9.49326 1.69073C9.55611 1.84435 9.58774 2.00895 9.5863 2.17492C9.58486 2.3409 9.55037 2.50492 9.48486 2.65743C9.41935 2.80993 9.32412 2.94787 9.20474 3.06317L3.01723 9.25067L9.20474 15.4382C9.43243 15.6739 9.55843 15.9897 9.55558 16.3174C9.55273 16.6452 9.42127 16.9587 9.18951 17.1904C8.95775 17.4222 8.64423 17.5537 8.31649 17.5565C7.98874 17.5594 7.67299 17.4334 7.43723 17.2057L0.365983 10.1344Z" fill="#4B5666"/></svg></button>',
      nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.63402 10.1344C9.86836 9.90001 10 9.58213 10 9.25067C10 8.91922 9.86836 8.60133 9.63402 8.36692L2.56277 1.29567C2.44746 1.17629 2.30953 1.08106 2.15702 1.01555C2.00452 0.950035 1.84049 0.915552 1.67452 0.91411C1.50854 0.912667 1.34394 0.944295 1.19032 1.00715C1.0367 1.07 0.897137 1.16281 0.77977 1.28018C0.662404 1.39755 0.569588 1.53711 0.506737 1.69073C0.443886 1.84435 0.412259 2.00895 0.413701 2.17492C0.415143 2.3409 0.449626 2.50492 0.515138 2.65743C0.580648 2.80993 0.675877 2.94787 0.795264 3.06317L6.98277 9.25067L0.795264 15.4382C0.567566 15.6739 0.441573 15.9897 0.444422 16.3174C0.447269 16.6452 0.578731 16.9587 0.810491 17.1904C1.04225 17.4222 1.35577 17.5537 1.68351 17.5565C2.01126 17.5594 2.32701 17.4334 2.56277 17.2057L9.63402 10.1344Z" fill="#4B5666"/></svg></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 426,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });


// filter icon

$('body').on('click', ".filterAccordian", function (event) {
    if (!this.classList.contains("is-open")) {
        this.classList.add("is-open")
        this.nextElementSibling.classList.add("is-open")
    }
    else {
        this.classList.remove("is-open")
        this.nextElementSibling.classList.remove("is-open")
    }

})

// *************for Dynamic language selector from each button*****************

// Get the selected language from local storage
let selectedLang = localStorage.getItem("translation-lab-lang");

// Find all elements that have the 'registration-form-link' attribute
let registrationFormLinkElements = document.querySelectorAll('a[registration-form-link]');

// Loop through each element
registrationFormLinkElements.forEach(function (registrationFormLinkElement) {
    // Get the href attribute of the current element
    let registrationFormLink = registrationFormLinkElement.getAttribute('href');
console.log("language",selectedLang);
    if (registrationFormLink) {
        // If no language is selected, default to 'nl'
        let lang = selectedLang === null ? 'en' : selectedLang;

        // Update the href with the selected or default language
        let updatedHref = registrationFormLink + (registrationFormLink.includes('?') ? '&' : '?') + 'lang=' + encodeURIComponent(lang);

        // Set the updated href back to the element
        registrationFormLinkElement.setAttribute('href', updatedHref);
    }
});



// Bydefault Language is Dutch
// $(document).ready(function() {
//     if (!localStorage.getItem("redirected")) {
//         let tgtcustomerfield = document.body;
//         let tgtcustomerdatastep = tgtcustomerfield.getAttribute("data-step");
//         // if (tgtcustomerdatastep) {
//             localStorage.setItem("redirected", "true");
//             window.location.href = "https://eu.expobazaar.com/nl";
//         // }
//     }
// });


// for language metafield
$(document).ready(function() {
    let tgtcustomerfield = document.body;
    let tgtcustomerdatastep = tgtcustomerfield.getAttribute("data-step");
    let tgtcustomerdatastep_current = localStorage.getItem("translation-lab-lang");
    let hasRedirected = localStorage.getItem("hasRedirected");
    if (tgtcustomerdatastep && !hasRedirected) {
        var firstTwoLetters = tgtcustomerdatastep.slice(0, 2).toLowerCase(); 
        if (firstTwoLetters === 'du') {
            firstTwoLetters = 'nl'; 
        }  if (firstTwoLetters === 'sp') {
            firstTwoLetters = 'es'; 
        } else if (firstTwoLetters === 'ge') {
            firstTwoLetters = 'de'; 
        }
        if (tgtcustomerdatastep_current === 'en') {
            // Redirect to the English site only once
            window.location.href = 'https://eu.expobazaar.com';
            localStorage.setItem("hasRedirected", "true"); // Set the flag to prevent multiple redirects
            return;
        } 
        else {
      
            let tgtUrl = window.location.href;
          if(tgtUrl === 'https://eu.expobazaar.com/en' ){
            window.location.href = 'https://eu.expobazaar.com'; 
              localStorage.setItem("hasRedirected", "true");
            return;
          }
          else{
            if (tgtUrl === "https://eu.expobazaar.com/") {
                tgtUrl += firstTwoLetters;
                window.location.href = tgtUrl;
            }
          }
        }
        localStorage.setItem("tgtcustomerdatastep", firstTwoLetters);
    }
});

// Featured collection slider

 $(document).ready(function() {
    var slider = $('.custom_slider');
    var totalItems = slider.children().length;

    if (totalItems > 6) {
      // Initialize the slick slider only if there are more than 6 items
      slider.slick({
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: true,
        prevArrow: '<button class="cstm_previ"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g opacity="0.3"><g clip-path="url(#clip0_443_7898)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.366 16.2584C10.1316 16.024 10 15.7062 10 15.3747C10 15.0432 10.1316 14.7254 10.366 14.4909L17.4372 7.4197C17.5525 7.30031 17.6905 7.20508 17.843 7.13957C17.9955 7.07406 18.1595 7.03958 18.3255 7.03813C18.4915 7.03669 18.6561 7.06832 18.8097 7.13117C18.9633 7.19402 19.1029 7.28684 19.2202 7.4042C19.3376 7.52157 19.4304 7.66113 19.4933 7.81475C19.5561 7.96837 19.5877 8.13297 19.5863 8.29895C19.5849 8.46492 19.5504 8.62895 19.4849 8.78145C19.4194 8.93396 19.3241 9.07189 19.2047 9.1872L13.0172 15.3747L19.2047 21.5622C19.4324 21.798 19.5584 22.1137 19.5556 22.4415C19.5527 22.7692 19.4213 23.0827 19.1895 23.3145C18.9577 23.5462 18.6442 23.6777 18.3165 23.6805C17.9887 23.6834 17.673 23.5574 17.4372 23.3297L10.366 16.2584Z" fill="#176B87"/></g></g><defs><clipPath id="clip0_443_7898"><rect width="30" height="30" fill="white" transform="translate(0 0.375)"/></clipPath></defs></svg></button>',
        nextArrow: '<button class="cstm_nexts"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><g clip-path="url(#clip0_443_7893)"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.634 16.2584C19.8684 16.024 20 15.7062 20 15.3747C20 15.0432 19.8684 14.7254 19.634 14.4909L12.5628 7.4197C12.4475 7.30031 12.3095 7.20508 12.157 7.13957C12.0045 7.07406 11.8405 7.03958 11.6745 7.03813C11.5085 7.03669 11.3439 7.06832 11.1903 7.13117C11.0367 7.19402 10.8971 7.28684 10.7798 7.4042C10.6624 7.52157 10.5696 7.66113 10.5067 7.81475C10.4439 7.96837 10.4123 8.13297 10.4137 8.29895C10.4151 8.46492 10.4496 8.62895 10.5151 8.78145C10.5806 8.93396 10.6759 9.07189 10.7953 9.1872L16.9828 15.3747L10.7953 21.5622C10.5676 21.798 10.4416 22.1137 10.4444 22.4415C10.4473 22.7692 10.5787 23.0827 10.8105 23.3145C11.0423 23.5462 11.3558 23.6777 11.6835 23.6805C12.0113 23.6834 12.327 23.5574 12.5628 23.3297L19.634 16.2584Z" fill="#176B87"/></g><defs><clipPath id="clip0_443_7893"><rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 30 0.375)"/></clipPath></defs></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });

